import { createSelector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { primitiveTypeUniq } from '@mews/fp';
import {
    getCompanionshipsAccountIdsByReservationIds,
    getUnassignedCompanionshipsAccountIds,
} from '@mews-commander/legacy-entities/src/ducks/companionships';
import { getCheckedReservationIds } from '../../selectors';

export const getCheckedReservationCompanionIds = createSelector(
    composeProps(
        getCompanionshipsAccountIdsByReservationIds,
        createPropsExtender('reservationIds', getCheckedReservationIds)
    ),
    getUnassignedCompanionshipsAccountIds,
    (checkedReservationCompanionIds: string[], unassignedCompanionIds: string[]) =>
        primitiveTypeUniq([...checkedReservationCompanionIds, ...unassignedCompanionIds])
);
